<template>
	<div :class="height_limit ? 'parent' : 'parent-long'">
		<div style="display:inline-block">
	        <div v-if="searchbar==true" class="search-field" style="float:left">
	            <button v-on:click="clear()" style="height:30px; width:40px;"><font-awesome-icon icon="times" /></button>
	    		<input v-model="search_term" @keydown.enter="setRouter(true)" @input="setRouter(false)"></input>
	            <button v-on:click="setRouter(true)" style="height:30px; width:40px;"><font-awesome-icon icon="search" /></button>
	        </div>

			<filtr
				v-if="filter_options!=null && filter_options.length>0"
				style="float:left"
				:id=id
				:filter_options=filter_options
				v-on:input="setData"
			></filtr>
		</div>

		<div class="scroll" v-bind:style="(buttonnames!=null)?'margin-bottom:50px':'margin-bottom:10px'">
			<table :key=update_key>
				<thead v-if="column_names.length>0">
					<tr>
						<th
						v-bind:colspan="column_names.length+2"
						class="table-header">
							{{table_name}} Table <button class="copy-table" v-on:click="copyTable()">Copy Table</button>
						</th>
					</tr>

					<tr>
						<th style="width:30px"></th>
						<th style="width:30px"></th>

						<th v-for="(name, index) in column_names">
							<div style="display:inline-block; white-space:nowrap;">
								{{name}}
								<button v-if="sort_value[index]==0" v-on:click="sort(index)"><font-awesome-icon icon="sort" /></button>
								<button v-else-if="sort_value[index]==1" v-on:click="sort(index)"><font-awesome-icon icon="sort-up" /></button>
								<button v-else-if="sort_value[index]==2" v-on:click="sort(index)"><font-awesome-icon icon="sort-down" /></button>
							</div>
						</th>
					</tr>
				</thead>
				<thead v-else-if="loading==true"><tr><th class="table-header">{{table_name}} Table Loading...</th></tr></thead>
                <thead v-else><tr><th class="table-header">{{table_name}} Table Empty</th></tr></thead>

				<tbody v-if="column_names.length>0" :key="updateKey">
					<tr v-for="(column, col) in column_data">

						<td style="width:30px">
							<input
							type="checkbox"
							v-on:change="selectID(col, $event.target.checked)"
							:checked="selectedIndexs.includes(col)"
							style="width:30px"
							></input>
						</td>
						<td style="width:30px"><button v-on:click="select(col)">{{button_name}}</button></td>

						<td v-for="(data, index) in column" v-bind:id="'tableRow-'+col">
							<div v-if="column_names[index] == 'Side' && data!='null'" v-bind:id="'side-'+col">
								{{data}}
							</div>
							<!--<div v-else-if="column_names[index] == 'Status' && data=='SentToQB'">
								{{data}}
							</div>-->
							<div v-else>
								{{data}}
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="nav-bar">
			<div>
				<button v-for="(buttonname, index) in buttonnames" v-if="perms.includes(buttonperms[index])" v-on:click="button(buttonnamefunction[index])">{{buttonname}}</button>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: '',
		searchbar:{
			type:Boolean,
			required:false,
			default:true
		},
        id: Number,
		table_name:{
			type:String,
			required:false,
			default:""
		},
		buttonnames:[],
		buttonperms:[],
		buttonnamefunction:[],
		filter_options:Array,
		height_limit:{
			type:Boolean,
			required:false,
			default:true
		},
		reroute: {
            type: String,
            required: false,
            default: ''
        },
		auto_reload:{
			type:Boolean,
			required:false,
			default:false
		},
		button_name: {
            type: String,
            required: false,
            default: 'Select'
        },
    },
	data() {
		return {
			perms:[],
			search_term:'',
			limit:200,
			column_names: [],
			column_data:[],
			sort_value:[],
			loading:true,
			selectedIndexs:[],
			updateKey:0,
			intervalID:'',
			filtr:[],
			update_key:0,
		}
	},
	async created () {
		this.perms = api.getPerms();
		this.search_term = this.term;
		var getLimit = api.getCookie("limit_"+this.id)
		if(getLimit!=null && getLimit!=undefined) { this.limit = getLimit }

		this.search(true)
		if(this.auto_reload){
			this.autoReload()
		}
	},
	methods: {
		autoReload(){
			this.intervalID = setInterval(function(){
				if(this.selectedIndexs.length == 0) {
					this.search(true)
				}
			}.bind(this), 5000);
		},
		async sort(index){
			this.sort_value.splice(index, 1, this.sort_value[index]+1);
			if(this.sort_value[index]>2)
				this.sort_value.splice(index, 1, 0);
			this.search(true)
		},
        async clear (){
            this.search_term = "";
            this.setRouter(true);
        },
		async setRouter(full){
			if(this.reroute!=''){
				if(this.search_term==''||this.search_term==undefined) {
					router.replace(this.reroute);
				}else {
					if(full){
						router.push(this.reroute+'?q='+this.search_term);
					}else{
						router.replace(this.reroute+'?q='+this.search_term);
					}
				}
			}

			this.search(full);
		},
		button(buttonname){
			this.$emit('button', buttonname, this.selectedIndexs, this.column_data);
			this.updateKey++;
			this.selectedIndexs = [];
		},
		async search (full){
			var currentTerm = this.search_term;
			var timeout = /*full?0:*/500;

			document.cookie="limit_"+this.id+"="+this.limit+";";

			setTimeout(() => {
				if(currentTerm!=this.search_term && this.search_term!=undefined){
					return;
				}else{
					this.loading=true;
					api.postData(
		                {
		                    type:"search",
		                    data:{
								pageid:this.id,
								fullsearch:full,
								limit:this.limit,
								data:[
									this.search_term,
									this.term,
			                    ],
								sort:this.sort_value,
								filter:this.filter_options
							}
		                }
		            ).then((res) => {
						if(res.data.data!=null && res.data.data.column_data!=null){
							if(JSON.stringify(this.column_data)!=JSON.stringify(res.data.data.column_data)){
								this.update_key++;
								this.clearColors()

								this.column_names = res.data.data.column_names;
								this.column_data = res.data.data.column_data;

								this.selectedIndexs = [];

								if(this.sort_value.length==0){
									for(let i = 0;i<res.data.data.column_names.length;i++) {
										this.sort_value[i] = 0;
									}
								}

								if(full){
									api.setWOColors()
								}
								this.setColors()
							}

						}
			        }).finally((res)=>{
						this.loading=false;
					});
				}
			}, timeout);
		},
		async clearColors(){
			if(this.column_names.includes('Side')){
				let position = this.column_names.indexOf('Side')
				for(let i = 0; i<this.column_data.length;i++){

					var element = document.getElementById('side-'+i).parentElement
					element.removeAttribute('style');
				}
			}

			if(this.column_names.includes('Color')){
				let position = this.column_names.indexOf('Color')
				for(let i = 0; i<this.column_data.length;i++){

					var row = document.getElementById('tableRow-'+i)
					row.removeAttribute('style');
				}
			}
		},
		async setColors(){
			let stateCheck = setInterval(() => {
				if (document.getElementById("tableRow-0")!=null) {
					clearInterval(stateCheck);

					if(this.column_names.includes('Side')){
						let position = this.column_names.indexOf('Side')
						for(let i = 0; i<this.column_data.length;i++){
							if(this.column_data[i][position]=="Port"){

								var element = document.getElementById('side-'+i).parentElement
								var style = 'background-color:#ffb5b5;';
								element.setAttribute('style', style);
							}
							else if(this.column_data[i][position]=="Starboard"){

								var element = document.getElementById('side-'+i).parentElement
								var style = 'background-color:#a5ffa5;';
								element.setAttribute('style', style);
							}
						}
					}

					if(this.column_names.includes('Color')){
						let position = this.column_names.indexOf('Color')
						for(let i = 0; i<this.column_data.length;i++){
							if(this.column_data[i][position]!=null){

								var color = this.column_data[i][position]
								var row = document.getElementById('tableRow-'+i)
								var style = 'background-color: #'+color+';';
								row.setAttribute('style', style);
							}
						}
					}
				}
			}, 100);
		},
		async copyTable(){
			var copyText = ''

			for(let i = 0;i < this.column_names.length;i++){
				copyText += this.column_names[i] + '\t'
			}
			copyText+='\n'

			for(let i = 0;i < this.column_data.length;i++){
				for(let j = 0; j< this.column_data[i].length;j++){
					copyText += this.column_data[i][j] + '\t'
				}
				copyText+='\n'
			}

			var el = document.createElement('textarea');
		    el.value = copyText;
		    document.body.appendChild(el);
		    el.select();
			el.setSelectionRange(0, 99999);
		    document.execCommand('copy');
		    document.body.removeChild(el);
			alert("copied to clipboard")
		},
		selectID(index, value){
			if(value==true){
				this.selectedIndexs.push(index);
			}else{
				var item = this.selectedIndexs.indexOf(index);
				if (item !== -1) {
			   		this.selectedIndexs.splice(item, 1);
				}
			}
		},
		select(index){
			api.postData(
                {
                    type:"select",
					data:{
						pageid:this.id,
						term:this.search_term,
					}
                }
            ).then((res) => {
				if(res.data.data.to!=null){
					router.push('/'+res.data.data.to+'?q='+this.column_data[index][res.data.data.select]);
					router.go(0)
				}
            })

			if(!this.selectedIndexs.includes(index)){
				this.selectedIndexs.push(index);
			}

			this.$emit('select', this.selectedIndexs, this.column_data);
			this.updateKey++;
			selectedIndexs = [];

		},
		setData(filtr, update){
			this.filtr = filtr
			if(update){
				this.search(true)
			}
		},
	},
	watch:{
		term(){
			this.search(true);
		},
	}
}
</script>

<style scoped>
.loader {
	border: 5px solid #f3f3f3; /* Light grey */
	border-top: 5px solid #3498db; /* Blue */
	border-radius: 50%;
	width: 30px;
	height: 30px;
	animation: spin 2s linear infinite;
}

@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/layouts/layout_12.vue